module.exports = __webpack_public_path__ + "static/media/SANANTH RAJ - Sales Manager.jpeg.146316cb.jpg";